<label class="field-label" [attr.for]="inputId"
    >{{ title | translate }}
    @if (required) {
        <span class="required">*</span>
    }
</label>
<mat-form-field appearance="outline" [class.is-disabled]="isDisabled">
    <!-- Use numbersOnly directive if type is a 'number' -->
    @if (type === 'number') {
        <input
            matInput
            type="text"
            [id]="inputId"
            [autocomplete]="autocomplete"
            [formControl]="control"
            [errorStateMatcher]="errorStateMatcher"
            (input)="onNumberInput($event)"
            (blur)="blurred.emit()"
            (focus)="focused.emit()"
            (keydown)="keydown.emit($event)"
            placeholder="{{ placeholder | translate }}"
            [mask]="mask"
            [attr.maxlength]="maxInputDigits === undefined ? null : allowDecimals ? maxInputDigits + 3 : maxInputDigits"
            onfocus="removeAttribute('readonly')"
            ontouchstart="removeAttribute('readonly');"
            readonly
            numbersOnly
            [numbersOnlyAllowDecimals]="allowDecimals"
        />
    }

    @if (type === 'textarea') {
        <textarea
            matInput
            [id]="inputId"
            [formControl]="control"
            [errorStateMatcher]="errorStateMatcher"
            (input)="onChange($event)"
            (blur)="blurred.emit()"
            (focus)="focused.emit()"
            (keydown)="keydown.emit($event)"
            placeholder="{{ placeholder | translate }}"
            [rows]="rows"
            [maxlength]="maxlength"
        ></textarea>
    }

    @if (type !== 'number' && type !== 'textarea') {
        <input
            matInput
            [type]="type"
            [id]="inputId"
            [autocomplete]="autocomplete"
            [formControl]="control"
            [errorStateMatcher]="errorStateMatcher"
            (input)="onChange($event)"
            (blur)="blurred.emit()"
            (focus)="focused.emit()"
            (keydown)="keydown.emit($event)"
            placeholder="{{ placeholder | translate }}"
            [mask]="mask"
            onfocus="removeAttribute('readonly')"
            ontouchstart="removeAttribute('readonly');"
            readonly
        />
    }
    @for (error of errors; track error) {
        <mat-error class="body-small-header" [translate]="error"></mat-error>
    }
    @if (hint) {
        <mat-hint [align]="hintAlign">{{ hint }}</mat-hint>
    }
    @if (suffix) {
        <span class="form-input__suffix" matSuffix>{{ suffix }}</span>
    }
</mat-form-field>
